import { AxisSwitcher, H1, Image, SpacerWrapper, useStepperContext } from '@ahmdigital/ui';
import React from 'react';

import { ImageWrapper, StyledButton, StyledP, StyledSection } from './styles';
import StepList from '../../../../components/step-list';
import welcomeMatImage from '../../../../../../public/assets/img/welcome-mat.svg';

const WELCOME_STEPS = [
  'Let’s get to know you.',
  'Pick the services you actually want to include.',
  'Choose the cover for you.',
];

const Welcome = () => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'goToNextStep' does not exist on type '{}'.
  const { goToNextStep } = useStepperContext();
  return (
    <StyledSection variant="large">
      <H1 looksLike="h2">Choose your own hospital & extras</H1>
      <StyledP>Get hospital & extras cover based on what’s important to you in a matter of minutes.</StyledP>
      <AxisSwitcher limit={2} threshold="61rem" space="1rem">
        <SpacerWrapper>
          <StepList isVertical steps={WELCOME_STEPS} />
        </SpacerWrapper>
        <ImageWrapper>
          <Image src={welcomeMatImage.src} width="100%" role="presentation" />
        </ImageWrapper>
      </AxisSwitcher>
      <StyledButton onClick={goToNextStep}>Let’s go</StyledButton>
    </StyledSection>
  );
};

export default Welcome;
